import { cx } from '@linaria/core';
import { CheckmarkIcon } from '@ui/kit';
import { useComponentEntry } from '@utils/component-framework';
import { list, button, modifiers } from './steps.style.js';
import { jsx } from 'react/jsx-runtime';
import { useUpdateLocationMutation } from '../../state/mutation.update-location.js';

function Steps(props) {
  const entry = useComponentEntry(props.entryKey);
  const updateLocation = useUpdateLocationMutation(props.entryKey);
  const handleGoToIndex = index => {
    updateLocation(index);
    props.pagination.goTo(index);
  };
  const onKeyDown = evt => {
    switch (evt.key) {
      case "ArrowLeft":
        {
          const prevChild = Array.from(evt.currentTarget.children)[props.pagination.activeItemIndex - 1];
          const prevButton = prevChild?.querySelector("button");
          prevButton?.click();
          prevButton?.focus();
          break;
        }
      case "ArrowRight":
        {
          const nextChild = Array.from(evt.currentTarget.children)[props.pagination.activeItemIndex + 1];
          const nextButton = nextChild?.querySelector("button");
          nextButton?.click();
          nextButton?.focus();
          break;
        }
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsx("ul", {
      className: list,
      onKeyDown: onKeyDown,
      children: props.cards.map((_, index) => {
        return /*#__PURE__*/jsx("li", {
          children: /*#__PURE__*/jsx("button", {
            className: cx(button, index === props.pagination.activeItemIndex && modifiers.active.className),
            onClick: () => handleGoToIndex(index),
            tabIndex: index === props.pagination.activeItemIndex ? undefined : -1,
            children: entry.data?.data.cards[index]?.flipped && /*#__PURE__*/jsx(CheckmarkIcon, {
              height: 7
            })
          })
        }, index);
      })
    })
  );
}

export { Steps };
//# sourceMappingURL=steps.js.map
